// import * as BABYLON from "babylonjs";

class Obstacle {
  constructor(mesh, label, isStatic) {
    this.mesh = mesh;
    this.label = label;

    mesh.rotationQuaternion = null;
    this.view = mesh.createInstance(label);


  }

  setConfig({ rotation, position, scaling }) {
    this.view.rotation = rotation;
    this.view.position = position;
    this.view.scaling = scaling;
  }

  createColliders() {
    this.colliders = this.mesh.getChildren().map((cMesh, index) => {
      const newCMesh = cMesh.createInstance(this.label + cMesh.name + index);
      newCMesh.position = cMesh.position;
      newCMesh.scaling = cMesh.scaling;
      newCMesh.rotationQuaternion = cMesh.rotationQuaternion;
      newCMesh.isVisible = false;
      newCMesh.isPickable = true;
      newCMesh.parent = this.view;
      return newCMesh;
    });
  }

  checkHit(target) {
    for (let i = 0; i < this.colliders.length; i++) {
      const mesh = this.colliders[i];
      if (target.intersectsMesh(mesh, true)) {
        return true;
      }
    }
    return false;
  }
  destroy() {
    this.colliders = null;
    this.mesh = null;

    this.view.parent = null;
    this.view.isVisible = false;
    this.view.dispose();
  }
}

export default Obstacle;
